import styles from './brand-section.module.css'

interface BrandSectionProps {
  logo: React.ReactNode
  text: string
  socialNetworkButtons?: Array<React.ReactNode>
}

export const BrandSection = ({
  logo,
  text,
  socialNetworkButtons,
}: BrandSectionProps) => (
  <div className={styles.container}>
    <div className={styles.logoContainer}>{logo}</div>
    <div className={styles.text}>{text}</div>
    {socialNetworkButtons?.length ? (
      <div className={styles.buttons}>
        {socialNetworkButtons.map((button, index) => (
          <div
            className={styles.buttonItem}
            key={`social-network-button-${index}`}
          >
            {button}
          </div>
        ))}
      </div>
    ) : null}
  </div>
)
